<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.invoicecharge_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/invoice/invoicecharge";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    labelWidth: 120,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: false,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "id",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "收费类型",
                                    prop: "chargeType",
                                    editDisabled: true,
                                    type: "select",
                                    dicUrl: "/api/blade-system/dict/dictionary?code=fee_sort",
                                    props: {
                                       label: "dictValue",
                                       value: "dictKey",
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择收费类型",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "商品名称",
                                    prop: "name",
                                    maxlength: 90,
                                    rules: [{
                                        required: true,
                                        message: "请输入商品名称",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "商品编码",
                                    prop: "code",
                                    maxlength: 19,
                                    rules: [{
                                        required: true,
                                        message: "请输入商品编码",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "商品简码",
                                    prop: "shortCode",
                                    maxlength: 50,
                                    rules: [{
                                        required: true,
                                        message: "请输入商品简码",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "税率(%)",
                                    prop: "rate",
                                    rules: [
                                      {
                                        pattern:/^[1-9][0-9]?$/,
                                        message: '格式错误',
                                      },
                                      {
                                        required: true,
                                        message: "请输入税率",
                                        trigger: "change"
                                      }
                                      ]
                                },
                                                                                                                {
                                    label: "规格型号",
                                    prop: "model",
                                    maxlength: 40,
                                    rules: [{
                                        required: false,
                                        message: "请输入规格型号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "计量单位",
                                    prop: "unit",
                                    maxlength: 20,
                                    rules: [{
                                        required: true,
                                        message: "请输入计量单位",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "优惠政策",
                                    type: 'select',
                                    prop: "policyFlag",
                                    dicData: [
                                       { label: '不使用', value: '0' },
                                       { label: '使用', value: '1' },
                                    ],
                                    rules: [{
                                        required: true,
                                        message: "请选择优惠政策标志",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "含税标志",
                                    prop: "taxFlag",
                                    type: "select",
                                    dicData: [
                                        { label: '否', value: '0' },
                                        { label: '是', value: '1' },
                                    ],
                                    rules: [{
                                        required: true,
                                        message: "请选择含税标志",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    hide: true,
                                    prop: "remark",
                                    rules: [{
                                        required: false,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.invoicecharge_add, false),
                    viewBtn: this.vaildData(this.permission.invoicecharge_view, false),
                    delBtn: this.vaildData(this.permission.invoicecharge_delete, false),
                    editBtn: this.vaildData(this.permission.invoicecharge_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
